module.exports = {"130227001":"栗乡街道","130227100":"兴城镇","130227101":"金厂峪镇","130227102":"洒河桥镇","130227103":"太平寨镇","130227104":"罗家屯镇","130227105":"东荒峪镇","130227106":"新集镇","130227107":"三屯营镇","130227108":"滦阳镇","130227109":"汉儿庄镇","130227110":"新庄子镇","130227111":"东莲花院镇","130227200":"白庙子乡","130227201":"上营乡","130227203":"渔户寨乡","130227204":"旧城乡","130227205":"尹庄乡","130227450":"栗乡工业产业聚集区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130227.json
// module id = 176
// module chunks = 0